module.exports = __webpack_public_path__ + "img/ner_tagger.72067437.png";